<div [formGroup]="formGroup" class="tw-flex tw-flex-col tw-gap-y-6 tw-w-full">
  <div class="tw-flex tw-gap-x-4 tw-min-w-max">
    <mat-form-field appearance="outline" floatLabel="always" class="tw-w-[330px]">
      <mat-label>配送設定名</mat-label>
      <input matInput formControlName="shipmentName" name="shipmentName" required />
      @if (formGroup.controls["shipmentName"].errors?.["required"]) {
        <mat-error>配送設定名を入力してください。</mat-error>
      }
      @if (formGroup.controls["shipmentName"].errors?.["isDuplicated"]) {
        <mat-error>既存の配送設定と別の名前を入力してください。</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always" class="tw-w-[330px]">
      <mat-label>繰り返し設定</mat-label>
      <mat-select
        name="repeatType"
        panelClass="matp-table-select-panel"
        formControlName="repeatType"
        required
      >
        <mat-option value="once">一度のみ</mat-option>
        <mat-option value="repetition">繰り返し</mat-option>
      </mat-select>
      @if (formGroup.controls["repeatType"].errors?.["required"]) {
        <mat-error>繰り返し設定を選択してください。</mat-error>
      }
    </mat-form-field>
  </div>
</div>
